export const insertLineBreakBeforeParen = (value?: string | null): string => {
    if (value == null) return "";
    const raw = String(value);
    if (raw.trim() === "") return "";
    return raw.replace(/\s*\(/, "\n(");
};
